import { ThunkAction } from 'redux-thunk';
import { State as LoginState } from '@telstra-connect/login';
import {
    loadTestStart,
    loadTestSuccess,
    loadTestError,
    // updateNbnTestResult,
} from '../../actions/load-nbn-results';
import {
    updateDiagnosticResult,
    deleteResultToast,
    addResultToast,
    addErrorToast,
    deleteErrorToast,
    updateNbnResultMessage,
    updateNbnErrorMessage
} from '../../actions/update-nbn-test-result';
import { INBNTestCreate } from '@telstra-connect/service-requests/state/create-nbn-test';
import { INBNTestDetailsPayload } from '@telstra-connect/service-requests/state/nbn-test-results';
import { Http } from '@telstra-connect/utils';
import { poll } from '../create-nbn-test/load';
const resultArray = [];

export function loadTestResult(testData: INBNTestCreate, serviceIds): ThunkAction<void, LoginState.ISignInState, void> {
    return (dispatch, getState) => {
        dispatch(loadTestStart());
        const diagnosticId = testData.diagnosticId;
        const service = (testData.services.map((item) => item.serviceId));
        const serviceIdList = serviceIds.toString();
        return Http
            .get<INBNTestDetailsPayload> ({
            url: `/nbnDiagnostics/v1/tests/${diagnosticId}`,
            queryString: {serviceIdList},
            state: getState(),

        })
            .then(
                (result) => {
                    if (result.data.diagnosticStatus === 'COMPLETED') {
                        dispatch(updateNbnResultMessage(result.data));
                        dispatch(addResultToast(result.data));
                        setTimeout(() => dispatch(deleteResultToast(result.data)), 45000);
                    }
                    if (result.data.diagnosticStatus === 'QUEUED' ||
                        result.data.diagnosticStatus === 'CREATED') {
                        dispatch(poll(testData, service))
                    }
                    dispatch(updateDiagnosticResult(result.data, result.data.diagnosticName));
                    resultArray.unshift(result.data);
                    dispatch(loadTestSuccess(resultArray));
                }
            )
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .catch((e) => {
                dispatch(updateNbnErrorMessage(testData.services, 'COMPLETED', 'ApiError'));
                dispatch(addErrorToast(testData.services, testData.diagnosticName, 'Error'));
                setTimeout(() => {
                    dispatch(deleteErrorToast(testData.services, testData.diagnosticName, 'Error'));
                }, 20000);
                dispatch(loadTestError('Error loading test results'));
            }
            );
    };
}
